import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  feTipoCFETexto: { value: null, matchMode: FilterMatchMode.CONTAINS },
  feSerieCFE: { value: null, matchMode: FilterMatchMode.CONTAINS },
  feNroCFE: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS,
  },
  fecha: { value: null, matchMode: FilterMatchMode.DATE_IS },
  razonSocial: { value: null, matchMode: FilterMatchMode.CONTAINS },
  rutCliente: { value: null, matchMode: FilterMatchMode.CONTAINS },
  oidLiquidacionWeb: { value: null, matchMode: FilterMatchMode.CONTAINS },
  clasificacionDocumento: { value: null, matchMode: FilterMatchMode.CONTAINS },
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  nombreViaje: { value: null, matchMode: FilterMatchMode.CONTAINS },
  armador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  moneda: { value: null, matchMode: FilterMatchMode.CONTAINS },
  importe: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
